// extracted by mini-css-extract-plugin
module.exports = {"row":"styles-module__row___BNP9-","fontWeightHeavy":"styles-module__fontWeightHeavy___1Ad81"};